__turbopack_context__.v({
  "body": "KibbeOffer-module__ATX_ZG__body",
  "look": "KibbeOffer-module__ATX_ZG__look",
  "offer": "KibbeOffer-module__ATX_ZG__offer",
  "proof": "KibbeOffer-module__ATX_ZG__proof",
  "title": "KibbeOffer-module__ATX_ZG__title",
});
